export class GameConstants {

    public static readonly VERSION = "0.0";
    public static readonly DEVELOPMENT = false;
    public static readonly VERBOSE = false;
    public static readonly GAME_WIDTH = 768;
    public static readonly GAME_HEIGHT = 1024;

    public static readonly DIFFICULTY_EASY = "easy";
    public static readonly DIFFICULTY_NORMAL = "medium";
    public static readonly DIFFICULTY_HERO = "hard";

    public static readonly TOTAL_EASY_LEVELS = 12;
    public static readonly TOTAL_NORMAL_LEVELS = 12;
    public static readonly TOTAL_HERO_LEVELS = 12;

    public static readonly SAVED_GAME_DATA_KEY = "bubble-sorting-data";
}
